import React from 'react';
import { useSelector } from 'react-redux';

import PlayerOverlay from 'components/pages/playback/PlayerOverlay';
import AreYouStillWatching from 'components/pages/AreYouStillWatching';

import { VideoCtvRedux } from 'store-types';

import PlayerFunnel from './PlayerFunnel';
import PlayerResource from './PlayerResource';
import Player from './Player';
import DRMProvider from './DRMProvider';

interface HeroPlaybackProps {
  videoId?: string | null;
  onVideoCompleted?: () => void;
  onError?: (error: unknown) => void;
  id?: string | null;
  isCarousel?: boolean;
  fullScreenPlayer?: boolean;
  slideNum?: number | null;
  inFocus?: boolean;
}

const HeroPlayback = ({
  videoId = null,
  onVideoCompleted = () => null,
  onError = () => null,
  id = null,
  isCarousel = false,
  fullScreenPlayer = false,
  slideNum = null,
}: HeroPlaybackProps) => {
  const isCcEnabled = useSelector((state: VideoCtvRedux) => state.closedCaptioning);
  return (
    <>
      <PlayerFunnel
        videoId={videoId}
        onError={onError}
        isCarousel
        render={({
          videoToPlay,
          videoToDisplay,
          isGTAutoplay,
          row,
          authorizedProvider,
          loading: authLoading,
          onPlaybackError,
          onSetResource,
        }) => (
          <PlayerResource
            videoToPlay={videoToPlay}
            videoToDisplay={videoToDisplay}
            row={row}
            isAutoplay={isGTAutoplay}
            authorizedProvider={authorizedProvider}
            onError={onError}
            isCarousel={isCarousel}
            slideNum={slideNum}
            render={({ resource, loading: resourceLoading }) => (
              <DRMProvider
                onError={onError}
                resource={resource}
                video={videoToPlay}
                render={({ resource: resourceWithDRM }) => {
                  return (
                    <Player
                      resource={resourceWithDRM}
                      onPlaylistComplete={onVideoCompleted}
                      onError={onPlaybackError}
                      loading={authLoading || resourceLoading}
                      onResourceSet={onSetResource}
                      id={id}
                      isCarousel={isCarousel}
                      fullScreenPlayer={fullScreenPlayer}
                      isCcEnabled={fullScreenPlayer && isCcEnabled}
                    />
                  );
                }}
              />
            )}
          />
        )}
      />
      {fullScreenPlayer && (
        <PlayerOverlay fullScreenPlayer={fullScreenPlayer} />
      )}
      {fullScreenPlayer && <AreYouStillWatching />}
    </>
  );
};

export default HeroPlayback;
